import styled from "styled-components"

import { maxWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import CroppedImage from "components/cropped-image"
import GeneralCard from "../base"
import { Headline } from "../base/styles"

export const Container = styled.div`
  position: relative;
`

export const StyledCard = styled(GeneralCard)`
  margin: 0;

  .card-header {
    padding: 0;
  }
`

export const ImageRegular = styled(CloudinaryImage)`
  padding-bottom: calc(377 / 253 * 100%);

  ${maxWidth.mobile`
    width: 100%;
    height: 14rem;
    padding-bottom: unset;
  `}
`

export const ImageCropped = styled(CroppedImage)`
  padding-bottom: calc(377 / 253 * 100%);

  ${maxWidth.mobile`
    width: 100%;
    height: 14rem;
    padding-bottom: unset;
  `}
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${maxWidth.mobile`
    display: none;
  `}
`

export const ImageHeadline = styled(Headline)`
  position: absolute;
  z-index: 3;
  left: 1.5rem;
  bottom: 2rem;
  color: #fff;
  font-weight: 400;
`

export const ImageOverlay = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    179.92deg,
    rgba(0, 0, 0, 0) 51.59%,
    rgba(0, 0, 0, 0.4) 76%,
    rgba(0, 0, 0, 0.5) 99.93%
  );
`
